import { useEffect } from "react";
import { useGetOrganizationId } from "../cacheQueries";
import { start, stop } from "./scannerStreamClient";

// Owns the scanner-status SSE connection's lifecycle. Mounted once at the app
// root (next to ScanningProvider) so a single EventSource serves every
// component on the page. Disconnects on logout / org change.
export function ScannerStreamProvider() {
  const { data: organizationId } = useGetOrganizationId();

  useEffect(() => {
    if (organizationId === null || organizationId === undefined) {
      stop();
      return;
    }
    start(organizationId);
    return () => {
      // Don't stop on every org-id change — start() short-circuits when the
      // id matches. Only stop when the id disappears (logout), handled above.
    };
  }, [organizationId]);

  return null;
}
